// Hold countdown text parts ("41h 20m left" / "52m left"), aligned to the server clock. Pure.

const MINUTE_MS = 60_000;

export type HoldCountdown = { expired: boolean; hours: number; minutes: number };

// serverNow − client clock at the moment the response arrived; add to Date.now() for server time.
export const serverClockOffsetMs = (serverNowIso: string | null | undefined, clientNowMs: number): number => {
  const server = serverNowIso ? Date.parse(serverNowIso) : Number.NaN;
  return Number.isFinite(server) ? server - clientNowMs : 0;
};

// Whole minutes rounded up, so a live hold never reads "0m left".
export const holdCountdown = (expiresAtIso: string, serverNowMs: number): HoldCountdown => {
  const expiresAt = Date.parse(expiresAtIso);
  const remaining = Number.isFinite(expiresAt) ? expiresAt - serverNowMs : 0;
  if (remaining <= 0) return { expired: true, hours: 0, minutes: 0 };
  const totalMinutes = Math.ceil(remaining / MINUTE_MS);
  return { expired: false, hours: Math.floor(totalMinutes / 60), minutes: totalMinutes % 60 };
};
